import React from 'react'
import { Card, Skeleton, Timeline, Space } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'

export default function SkeletonCommentHistory({ count = 1 }) {
    const items = Array.from({ length: count }).map((_, idx) => ({
        dot: <ClockCircleOutlined style={{ fontSize: 14 }} />,
        children: (
            <Card
                key={idx}
                size="small"
                styles={{ body: { padding: 12 } }}
                // bordered
            >
                <Space direction="vertical" size={6} style={{ width: '100%' }}>
                    {/* Header row */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 80 }}
                        />
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 120 }}
                        />
                    </div>

                    {/* Description block */}
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />

                    {/* Attachments placeholder */}
                    <Space size={8}>
                        <Skeleton.Image
                            active
                            style={{ width: 96, height: 72 }}
                        />
                        <Skeleton.Image
                            active
                            style={{ width: 96, height: 72 }}
                        />
                    </Space>
                </Space>
            </Card>
        ),
    }))

    return (
        <Card
            title="Comment History"
            bordered={false}
            styles={{ body: { paddingTop: 8 } }}
        >
            <Timeline
                mode="left"
                items={items}
                style={{ marginLeft: 8, marginTop: 8 }}
            />
        </Card>
    )
}
